export default "__VITE_PUBLIC_ASSET__6be0c351__"